import { Component, h } from '@stencil/core';
import store from '../../../helpers/store';
import { ApiCall } from '../../../helpers/ApiCall';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';

@Component({
  tag: 'state-transition',
  styleUrl: 'state-transition.css',
  shadow: false,
})
export class StateTransition {
  async componentWillLoad() {
    store.flowStatus = await ApiCall.instance.GetNextFlowState();
  }

  render() {
    return (
      <div class="container">
        <div class="row">
          <div class="div-ci align-center">
            <img src={loaderImg}></img>
          </div>
        </div>
      </div>
    );
  }
}
